var _g, _circle, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimefilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Time_filter",
    "data-name": "Time filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 42,
    viewBox: "0 0 51 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dates_filter",
    "data-name": "Dates filter",
    transform: "translate(-1620 -616.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802",
    transform: "translate(1628.775 616.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6799",
    "data-name": "Path 6799",
    d: "M1.826,0H4.26A1.826,1.826,0,0,1,6.085,1.826V3.043A1.826,1.826,0,0,1,4.26,4.868H1.826A1.826,1.826,0,0,1,0,3.043V1.826A1.826,1.826,0,0,1,1.826,0Z",
    transform: "translate(4.868 0) rotate(90)",
    fill: "#23558d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2093",
    "data-name": "Rectangle 2093",
    transform: "translate(1623.714 632.966)",
    fill: "none",
    stroke: "#24568f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.769,
    height: 5.769,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.769,
    height: 4.769,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6803",
    "data-name": "Path 6803",
    d: "M0,0H32.708",
    transform: "translate(1620.559 629.388)",
    fill: "none",
    stroke: "#24568f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836",
    transform: "translate(1640.312 616.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6799-2",
    "data-name": "Path 6799",
    d: "M1.826,0H4.26A1.826,1.826,0,0,1,6.085,1.826V3.043A1.826,1.826,0,0,1,4.26,4.868H1.826A1.826,1.826,0,0,1,0,3.043V1.826A1.826,1.826,0,0,1,1.826,0Z",
    transform: "translate(4.868 0) rotate(90)",
    fill: "#24568f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2107",
    "data-name": "Rectangle 2107",
    transform: "translate(1620 621.971)",
    fill: "none",
    stroke: "#24568f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 30,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 33,
    height: 28,
    rx: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2108",
    "data-name": "Rectangle 2108",
    transform: "translate(1630.636 632.966)",
    fill: "none",
    stroke: "#24568f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.769,
    height: 5.769,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.769,
    height: 4.769,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2109",
    "data-name": "Rectangle 2109",
    transform: "translate(1637.559 632.966)",
    fill: "none",
    stroke: "#24568f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.769,
    height: 5.769,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.769,
    height: 4.769,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2110",
    "data-name": "Rectangle 2110",
    transform: "translate(1644.481 632.966)",
    fill: "none",
    stroke: "#24568f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.769,
    height: 5.769,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.769,
    height: 4.769,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2111",
    "data-name": "Rectangle 2111",
    transform: "translate(1623.714 641.043)",
    fill: "none",
    stroke: "#24568f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.769,
    height: 5.769,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.769,
    height: 4.769,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2112",
    "data-name": "Rectangle 2112",
    transform: "translate(1630.636 641.043)",
    fill: "none",
    stroke: "#24568f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.769,
    height: 5.769,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.769,
    height: 4.769,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2113",
    "data-name": "Rectangle 2113",
    transform: "translate(1637.559 641.043)",
    fill: "none",
    stroke: "#24568f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.769,
    height: 5.769,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.769,
    height: 4.769,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2114",
    "data-name": "Rectangle 2114",
    transform: "translate(1644.481 641.043)",
    fill: "none",
    stroke: "#24568f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.769,
    height: 5.769,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.769,
    height: 4.769,
    rx: 0.5,
    fill: "none"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(18 9)",
    fill: "#eff0f1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    transform: "translate(21 12)",
    fill: "#eff0f1",
    stroke: "#24568f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 12.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7344",
    "data-name": "Path 7344",
    d: "M1546.267,624.8h11.874l-4.828,6.3v6.477l-2.909,2.34v-8.817Z",
    transform: "translate(-1517.787 -605.026)",
    fill: "none",
    stroke: "#24568f",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimefilter);
export default __webpack_public_path__ + "static/media/timefilter.1e1223603df851c80ba6432dfbfc9a3d.svg";
export { ForwardRef as ReactComponent };